export const errorLabels = {
  CURRENT_PASSWORD: "PASSWORD",
  NEW_EMAIL: "EMAIL_ADDRESS",
  MONTHLY: "MONTHLY_PRICE",
};
